import React, { useEffect, useState, useRef } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HeaderBar from "../HeaderBar/HeaderBar";
import styles from "./CallSetting.module.css";
import ListeningAffirmations from "./ListeningAffirmation";
import SpeechSetting from "./SpeechSetting";
import BackgroundSound from "./BackgroundSound";
import TransferSetting from "./TransferSetting";
import CallScreenSetting from "./CallScreenSetting";
import CallSeting1 from "./CallSeting1";
import LeadSetting from "./LeadSetting";
import Footer2 from "../AgentDetails/Footer/Footer2";
import PhoneInput from "react-phone-input-2";
import { useDashboardStore } from "../../Store/agentZustandStore";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import CallRecording from "../CallRecording/CallRecording";
import { API_BASE_URL, token, updateAgentFromBackend } from "../../Store/apiStore";
import axios from "axios";
import decodeToken from "../../lib/decodeToken";

const countryMappings = {
  us: { code: "+1", flag: "us" },
  ca: { code: "+1", flag: "ca" },
  gb: { code: "+44", flag: "gb" },
};

export default function CallSetting() {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState("panel1");
  const { agents, setHasFetched } = useDashboardStore();
  const location = useLocation();
  const { selectedAgentname, fromPage } = location.state || {};
  // End Call on Silence — stored in SECONDS. Range 60s (1 min) → 1800s (30 min).
  // Defaults to the 1-minute minimum.
  const [frequency, setFrequency] = useState(60);
  const [frequency1, setFrequency1] = useState(0.2);
  const [savingSilence, setSavingSilence] = useState(false);
  const [silenceHover, setSilenceHover] = useState(false);

  // Slider range for End Call on Silence. Minimum 1 minute (60s).
  const SILENCE_MIN = 60;
  const SILENCE_MAX = 1800; // 30 minutes

  // Show seconds under a minute, otherwise minutes with one decimal.
  const formatSilence = (sec) =>
    sec < 60 ? `${Math.round(sec)} s` : `${(sec / 60).toFixed(1)} m`;

  // Save End Call on Silence (ms). DEBOUNCED — while the user drags rapidly we
  // only fire the API ~400ms after the last change, and the slider is NEVER
  // disabled (disabling mid-drag is what made it feel "stuck").
  const silenceCommitTimer = useRef(null);
  const commitSilence = (sec) => {
    const agentIdForSave = sessionStorage.getItem("SelectAgentId") || agentId;
    if (!agentIdForSave) return;
    clearTimeout(silenceCommitTimer.current);
    silenceCommitTimer.current = setTimeout(async () => {
      try {
        setSavingSilence(true);
        await updateAgentFromBackend({
          agent_id: agentIdForSave,
          end_call_after_silence_ms: Math.round(sec * 1000),
        });
      } catch (error) {
        console.error("Failed to update end_call_after_silence_ms:", error);
      } finally {
        setSavingSilence(false);
      }
    }, 400);
  };
  const token = localStorage.getItem("token") || "";
  const decodeTokenData = decodeToken(token);
  const userIdFromToken = decodeTokenData?.id || "";
  const [userId, setUserId] = useState(userIdFromToken);
  const [selectedAgent, setSelectedAgent] = useState(selectedAgentname || "");
  const [settings, setSettings] = useState({
    phoneNumber: "",
    selectedCountry: "us",
    ringDuration: 30,
    maxCallDuration: 3600,
    endCallOnSilence: false,
    conversationalNods: false,
  });
  ;
  const agent = agents.find(
    (agent) => `${agent.agentName}-${agent.agentCode}` === selectedAgent
  );
  const agentId = agent?.agent_id || location.state?.agentId;
  const businessId = agent?.businessId || location.state?.businessId;

  const prevSettings = useRef(settings);
  const isInitialLoad = useRef(true);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleInputChange = (field, value) => {
    setSettings((prev) => ({ ...prev, [field]: value }));
    console.log(`Input changed: ${field} = ${value}`);
  };

  const dropdownOptions = agents.map(
    (agent) => `${agent.agentName}-${agent.agentCode}`
  );

  // Header h2 me agent ka naam. Store khaali ho (direct/refresh visit) to
  // FooterNew ke bheje "Naam-Code" se code hata ke naam nikaalo.
  const agentNameFromState = (() => {
    const raw = String(selectedAgent || "");
    const cut = raw.lastIndexOf("-");
    const name = cut > 0 ? raw.slice(0, cut) : raw;
    return name && name !== "undefined" ? name : "";
  })();
  const headerAgentName =
    agent?.agentName || location.state?.agentName || agentNameFromState;
  // Dropdown sirf tab jab chunne ko sach me ek se zyada agent hon — warna
  // naam h2 me hi dikhta hai (do baar nahi).
  const showAgentDropdown = dropdownOptions.length > 1;
  const placeDetails = sessionStorage.getItem("placeDetailsExtract");
  useEffect(() => {

    if (placeDetails) {
      const parsedDetails = JSON.parse(placeDetails);
      if (parsedDetails && parsedDetails.phone && parsedDetails.country) {
        const phone = parsedDetails.phone;
        const countryName = parsedDetails.country.toLowerCase();
        const countryData =
          countryMappings[countryName] || countryMappings["us"];
        const formattedPhone =
          phone.startsWith("+") && phone.startsWith(countryData.code)
            ? phone
            : `${countryData.code}${phone}`;

        setSettings((prevSettings) => ({
          ...prevSettings,
          phoneNumber: formattedPhone,
          selectedCountry: countryData.flag,
        }));
      }
    }
  }, [placeDetails]);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      prevSettings.current = settings;
      return;
    }
  }, [settings, selectedAgent, agents]);

  useEffect(() => {
    const selectedAgentId = sessionStorage.getItem("SelectAgentId");
    console.log(selectedAgentId, "selectedAgentId")

    if (selectedAgentId) {
      const fetchAgentDetails = async () => {
        try {
          const res = await axios.get(
            `${API_BASE_URL}/agent/getAgent/${selectedAgentId}`,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const silenceDurationMs = res.data.end_call_after_silence_ms;
          if (silenceDurationMs != null) {
            const silenceDurationSec = silenceDurationMs / 1000;
            // Clamp into the slider's 0–1800s (0–30 min) range.
            setFrequency(
              Math.min(Math.max(silenceDurationSec, SILENCE_MIN), SILENCE_MAX)
            );
          }
        } catch (error) {
          console.error("Error fetching agent details:", error);
        }
      };
      fetchAgentDetails();
    } else {
      console.log("No selectedAgentId found in sessionStorage.");
    }
  }, []);

  return (
    <div>
      <div className={styles.headersection}>
        {/* Chhota label "Call Settings For" upar (h6), agent ka naam bada neeche
            — ek agent ho to h2 me, kai hon to dropdown me. */}
        <HeaderBar
          subtitle="Call Settings For"
          title={showAgentDropdown ? "" : headerAgentName}
          dropdownOptions={showAgentDropdown ? dropdownOptions : []}
          selectedAgent={selectedAgent}
          onDropdownChange={setSelectedAgent}
        />
      </div>

      <div className={styles.CallSettingContainer}>
        {/* Call Recording toggle — its own card at the top. CallRecording
            renders the question text on the left and the switch on the right. */}
        <div className={styles.recordingCard}>
          <CallRecording agentId={agentId} businessId={businessId} />
        </div>

        <h2 className={styles.agentSettingTitle}>Agent Setting</h2>

        <div className={styles.settingsList}>
          {/* Agent Custom Greeting */}
          <div className={styles.settingCard}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                padding: "4px 0",
              }}
              onClick={() => {
                sessionStorage.setItem("naviateFrom", "dashboard");
                navigate("/edit-name-avtar", {
                  state: {
                    agentId,
                    businessId,
                    agentName: agent?.agentName,
                  },
                });
              }}
            >
              <div>
                <p className={styles.settingCardTitle} style={{ margin: 0 }}>
                  Agent Greeting
                </p>
                <p style={{ fontSize: "13px", color: "#6e6a7c", margin: "4px 0 0 0" }}>
                  Customize the opening message spoken by your agent.
                </p>
              </div>
              <span
                style={{
                  background: "#f0ebfc",
                  color: "#6524eb",
                  fontWeight: 600,
                  fontSize: "13px",
                  padding: "6px 14px",
                  borderRadius: "20px",
                  whiteSpace: "nowrap",
                }}
              >
                <img src="/svg/edit-icon2.svg" alt="" />
              </span>
            </div>
          </div>

          {/* Background Sound — interactive dropdown, shown FIRST. */}
          <div className={styles.settingCard}>
            <p className={styles.settingCardTitle}>Background Sound</p>
            <div className={styles.settingCardBody}>
              <BackgroundSound agentId={agentId} />
            </div>
          </div>

          {/* Speech Setting (Interruption Sensitivity + Responsiveness) — no card title. */}
          <div className={styles.settingCard}>
            <div className={styles.settingCardBody}>
              <SpeechSetting onChange={handleInputChange} />
            </div>
          </div>

          {/* End Call on Silence */}
          <div className={styles.settingCard}>
            <p className={styles.settingCardTitle}>End Call on Silence</p>
            <div className={styles.settingCardBody}>
              <div
                className={styles.sliderContainer}
                onPointerEnter={() => setSilenceHover(true)}
                onPointerLeave={() => setSilenceHover(false)}
              >
                <p className={styles.description}>End the call if user stays silent for extended period of time.</p>
                <div className={styles.sliderWrapper}>
                  <input
                    type="range"
                    min={SILENCE_MIN}
                    max={SILENCE_MAX}
                    step="10"
                    value={frequency}
                    onChange={(e) => setFrequency(parseFloat(e.target.value))}
                    onMouseUp={(e) => commitSilence(parseFloat(e.target.value))}
                    onTouchEnd={(e) => commitSilence(parseFloat(e.target.value))}
                    className={styles.sliderRange}
                    style={{
                      background: `linear-gradient(to right, #693bff ${((frequency - SILENCE_MIN) / (SILENCE_MAX - SILENCE_MIN)) * 100
                        }%, #fff ${((frequency - SILENCE_MIN) / (SILENCE_MAX - SILENCE_MIN)) * 100
                        }%)`,
                      cursor: "pointer",
                    }}
                  />
                  <span className={styles.sliderValue}>
                    {formatSilence(frequency)}
                  </span>
                </div>
                <div
                  className={`${styles.minMaxRow} ${silenceHover ? styles.minMaxRowVisible : ""
                    }`}
                >
                  <span>Min</span>
                  <span>Max</span>
                </div>
              </div>
            </div>
          </div>

          {/* Call Transfer — Ring Duration + Voicemail Detection (Python agents only). */}
          <TransferSetting />

          {/* iOS / Android Call Screen Handling on transfers (Python agents only). */}
          <CallScreenSetting variant="transfer" className={styles.settingCard} />

          {/* Conversational Nods */}
          {/* <div className={styles.settingCard}>
            <p className={styles.settingCardTitle}>Conversational Nods</p>
            <div className={styles.settingCardBody}>
              <ListeningAffirmations
                conversationalNods={settings.conversationalNods}
                onChange={(value) =>
                  handleInputChange("conversationalNods", value)
                }
              />
            </div>
          </div> */}
        </div>
      </div>
      {/* <Footer2  userId = {userId}/> */}
    </div>
  );
}

